/**
 * Helper: CSS classes
 * -----------------------------------------------------------------------------
 * Global configuration for css classes.
 * - Used to provide consistency and keep DRY for our toggle classes.
 */
export default {
  active: 'is-active',
  adding: 'is-adding',
  added: 'is-added',
  collapsed: 'is-collapsed',
  disabled: 'is-disabled',
  focused: 'is-focused',
  hidden: 'is-hidden',
  lazyload: 'lazyload',
  lazyloaded: 'lazyloaded',
  loaded: 'is-loaded',
  loading: 'is-loading',
  locked: 'is-locked',
  removing: 'is-removing',
  sticky: 'is-sticky',
  tabbable: 'is-tabbable',
  transitioning: 'is-transitioning',
};
